<template>
    <div class="card faq-item mb-3">
        <button
            type="button"
            @click="$emit('toggle')"
            class="faq-item__header btn btn-faq"
            data-toggle="collapse"
            :data-target="`faq-collapse-${index}`"
            aria-expanded="false"
        >
            <span>{{ index + 1 }}. {{ question }}</span>
            <a-icon
                icon="Chevron"
                :iconConfig="chevronConfig"
                class="faq-item__header__chevron"
            />
        </button>
        <div
            class="collapse faq-item__content card-body"
            :id="`faq-collapse-${index}`"
            :class="{ show: active }"
            v-html="$options.filters.sanitizeHtml(answer)"
        />
    </div>
</template>

<script>
import AIcon from '../../global/AIcon.vue'
export default {
    components: { AIcon },
    name: 'FaqItem',
    computed: {
        active() {
            return this.uniqueIndex === this.activeFaqIndex
        },
        chevronConfig() {
            return {
                down: !this.active,
                up: this.active
            }
        }
    },
    props: {
        activeFaqIndex: {
            type: Number,
            default: -1
        },
        question: {
            type: String,
            default: ''
        },
        answer: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        },
        uniqueIndex: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss">
.faq-item {
    transition: all 0.3s ease-out;
    &:hover {
        border: 1px solid var(--color-dark);
        .faq-item__header {
            opacity: 0.7;
        }
    }
    &__header {
        cursor: pointer;
        span {
            white-space: normal;
            text-align: left;
        }
        &__chevron {
            .text-body {
                color: var(--color-primary) !important;
            }
        }
    }
    &__content {
        display: block;
    }
}
</style>
